import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-e245a48c"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "login"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "header"
}, [/*#__PURE__*/_createElementVNode("img", {
  style: {
    "padding-top": "18px",
    "padding-left": "30px"
  },
  src: "/assets/icon/upi.png",
  alt: ""
})], -1));

const _hoisted_3 = {
  class: "van-doc-card"
};
const _hoisted_4 = {
  class: "content"
};

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "Payment", -1));

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("hr", {
  style: {
    "border-top": "1px solid #5728a8"
  }
}, null, -1));

const _hoisted_7 = {
  class: "form-group"
};

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "Pay Amount", -1));

const _hoisted_9 = ["value"];

const _hoisted_10 = /*#__PURE__*/_createTextVNode("copy");

const _hoisted_11 = {
  class: "form-group"
};

const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "UPI-ID", -1));

const _hoisted_13 = ["value"];

const _hoisted_14 = /*#__PURE__*/_createTextVNode("copy");

const _hoisted_15 = {
  class: "form-group"
};

const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, "UTR", -1));

const _hoisted_17 = /*#__PURE__*/_createTextVNode("Proceed");

const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "notes"
}, [/*#__PURE__*/_createElementVNode("p", {
  style: {
    "text-align": "justify",
    "color": "brown"
  }
}, " Warning: Please fill in the UTR number correctly, if you do not fill in your recharge will not be able to get into the account.")], -1));

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_button = _resolveComponent("van-button");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_hoisted_2, _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _hoisted_6, _createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("input", {
    type: "text",
    class: "form-control",
    value: $data.orderinfo.amount,
    disabled: ""
  }, null, 8, _hoisted_9), _createVNode(_component_van_button, {
    plain: "",
    hairline: "",
    size: "small",
    type: "primary",
    class: "inbtn",
    onClick: _cache[0] || (_cache[0] = $event => $options.copy($data.orderinfo.amount))
  }, {
    default: _withCtx(() => [_hoisted_10]),
    _: 1
  })]), _createElementVNode("div", _hoisted_11, [_hoisted_12, _createElementVNode("input", {
    type: "text",
    class: "form-control",
    value: $data.orderinfo.collection_upi_id,
    disabled: ""
  }, null, 8, _hoisted_13), _createVNode(_component_van_button, {
    plain: "",
    hairline: "",
    size: "small",
    type: "primary",
    class: "inbtn",
    onClick: _cache[1] || (_cache[1] = $event => $options.copy($data.orderinfo.collection_upi_id))
  }, {
    default: _withCtx(() => [_hoisted_14]),
    _: 1
  })]), _createElementVNode("div", _hoisted_15, [_hoisted_16, _withDirectives(_createElementVNode("input", {
    type: "text",
    class: "form-control",
    maxlength: "12",
    placeholder: "12 Digit UTR",
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.utrvalue = $event)
  }, null, 512), [[_vModelText, $data.utrvalue]])])]), _createVNode(_component_van_button, {
    class: "cofbutton",
    onClick: $options.submitutr,
    disabled: $data.disabled
  }, {
    default: _withCtx(() => [_hoisted_17]),
    _: 1
  }, 8, ["onClick", "disabled"])]), _hoisted_18]);
}